var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8198 17.0316C20.3325 17.9064 19.6889 19 18.6649 19H5.33472C4.30869 19 3.66808 17.9047 4.1798 17.0316L10.845 5.65584C11.3579 4.78059 12.6427 4.78218 13.1548 5.65584L19.8198 17.0316V17.0316ZM11.9999 14.6797C11.2942 14.6797 10.7221 15.2428 10.7221 15.9375C10.7221 16.6322 11.2942 17.1953 11.9999 17.1953C12.7056 17.1953 13.2777 16.6322 13.2777 15.9375C13.2777 15.2428 12.7056 14.6797 11.9999 14.6797ZM10.7867 10.1585L10.9928 13.8773C11.0024 14.0513 11.1486 14.1875 11.3256 14.1875H12.6741C12.8512 14.1875 12.9973 14.0513 13.007 13.8773L13.213 10.1585C13.2234 9.97055 13.0714 9.8125 12.8802 9.8125H11.1196C10.9283 9.8125 10.7763 9.97055 10.7867 10.1585V10.1585Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.6762c5a244b18f1781a1aa6e274a9043.svg";
export { ForwardRef as ReactComponent };